import { useState } from 'react';
import { Modal, RadioCardGroup } from '@praktio/common-ui';

import { DownloadOption, DownloadReportModalProps } from './DownloadReportModal.types';

import './DownloadReportModal.scss';

const DOWNLOAD_OPTIONS = [
  {
    id: 'filtered',
    label: 'Filtered results',
    description: 'Download only the data matching your current filters',
    value: DownloadOption.Filtered,
  },
  {
    id: 'full',
    label: 'Full report',
    description: 'Download all data without any filters applied',
    value: DownloadOption.Full,
  },
];

const DownloadReportModal = ({
  show,
  isDownloading = false,
  onHide,
  onDownload,
}: DownloadReportModalProps) => {
  const [selectedOption, setSelectedOption] = useState<DownloadOption>(DownloadOption.Filtered);

  const handleSave = () => {
    onDownload(selectedOption);
  };

  const handleHide = () => {
    setSelectedOption(DownloadOption.Filtered);
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={handleHide}
      onSave={handleSave}
      title="Download Report"
      saveText={isDownloading ? 'DOWNLOADING...' : 'DOWNLOAD'}
      className="DownloadReportModal"
      disableSave={isDownloading}
    >
      <div className="DownloadReportModal_Content">
        <p className="DownloadReportModal_Description">
          You have filters applied. Would you like to download the filtered results or the full
          report?
        </p>

        <RadioCardGroup
          name="downloadOption"
          options={DOWNLOAD_OPTIONS}
          value={selectedOption}
          onChange={(value) => setSelectedOption(value as DownloadOption)}
        />
      </div>
    </Modal>
  );
};

export default DownloadReportModal;
